import { mediaUrl } from '@techsofit/app-kit';
import { cn } from '@techsofit/ui';
import { valueLabel } from '../lib/goals';

/** A progress photo with the captured measurement overlaid (Strava-style). */
export function StatOverlayPhoto({
  url,
  label,
  value,
  unit,
  delta,
  tall = false,
  className,
}: {
  url: string;
  label: string;
  value: number | null;
  unit: string;
  /** Signed change to show as a chip (only rendered on the "after"). */
  delta?: number | null;
  tall?: boolean;
  className?: string;
}) {
  return (
    <figure className={cn('relative overflow-hidden rounded-card bg-dark', className)}>
      <img src={mediaUrl(url)} alt={label} className={cn('w-full object-cover', tall ? 'aspect-[4/5]' : 'aspect-square')} />
      <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/10 to-transparent" />
      <figcaption className="absolute inset-x-0 bottom-0 flex items-end justify-between p-3">
        <div className="min-w-0">
          <p className="text-[0.7rem] font-medium uppercase tracking-wide text-on-dark/70">{label}</p>
          {value != null && (
            <p className="font-display text-2xl font-bold leading-tight text-on-dark tabular">{valueLabel(value, unit)}</p>
          )}
        </div>
        {delta != null && delta !== 0 && (
          <span className="shrink-0 rounded-pill bg-accent px-2 py-0.5 text-xs font-semibold text-accent-ink tabular">
            {delta < 0 ? '−' : '+'}
            {valueLabel(Math.abs(delta), unit)}
          </span>
        )}
      </figcaption>
    </figure>
  );
}
